

















































import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import {
  getSubTaskList,
  getTaskInstance,
  subListColumns,
  recordFinishTime
} from '../../../service/platform'
import { getUrlParams } from '../../../utils/urlUtils'
import ViewTask from '../components//ViewTask.vue'
import ViewAuditHistory from '../components/ViewAuditHistory.vue'
import { ExtraData, Level2Task, SendMessageData, TaskInstance } from '../types/task'
import { USER_ID } from '../../../service/constant'

@Component({
  components: { ViewTask, ViewAuditHistory }
})
export default class SubTaskList extends Vue {
  public subListColumns: any[] = subListColumns
  public dataList: Level2Task[] = []
  public task: TaskInstance | {} = {} // 一级任务
  public pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showTotal: (total, range) => `共${total}条`
  }

  private isShowViewTask = false

  private instance: TaskInstance | {} = {} // 子任务
  private extraData: ExtraData | {} = {} // 子任务处理时填写信息
  private sendMessageData: SendMessageData | {} = {} // 子任务处理时额外信息

  private showAuditHistory = false

  public mounted() {
    this.loadData()
  }

  public async loadData() {
    const task_id = getUrlParams().id
    if (!task_id) return
    let task = await getTaskInstance(task_id)
    this.task = task || {}

    this.getDataList(task_id, 1)
  }

  public async clickShowViewTask(instance_id: string) {
    let instance = (await getTaskInstance(instance_id)) as TaskInstance
    if (!instance || !instance.id) return

    this.instance = instance
    this.reset()
    this.isShowViewTask = true
    this.getFinishTime(instance_id, instance.current_task.id)
  }

  public async clickShowAuditHistory(instance_id: string) {
    let instance = (await getTaskInstance(instance_id)) as TaskInstance
    if (!instance || !instance.id) return

    this.instance = instance
    this.showAuditHistory = true
  }

  private async getDataList(task_id, pageNum) {
    const { count, current_page, contents } = await getSubTaskList(
      task_id,
      pageNum,
      this.pagination.pageSize
    )
    let temp = contents
    const dataList = temp.map((item, index) => ({
      index: index * this.pagination.pageSize + 1,
      ...item
    }))

    this.dataList = dataList
    this.pagination.total = count
    this.pagination.current = current_page
  }

  private handlePaginationChange(pagination) {
    const task_id = getUrlParams().id
    if (!task_id) return

    this.getDataList(task_id, pagination.current)
  }

  private async reload() {
    await this.loadData()
    if (this.dataList.length == 0) {
      this.$router.replace({ path: '/platform/my-task' }).catch((_) => {})
    }
  }

  private reset() {
    const instance = this.instance as TaskInstance
    console.log(instance.user_id)
    this.extraData = {
      instance_id: instance.id,
      task_id: instance.current_task.id,
      pic_data: [],
      word_data: [],
      content_data: [{ content: '', sensitive_type: [] }],
      auditor: this.$store.state[USER_ID] || '', // 图片审核传递当前用户ID
      subject_name: instance.resource && instance.resource.subject_name,
      business_type_name: instance.resource && instance.resource.business_type_name,
      doc_id: instance.resource && instance.resource.doc_id,
      resource_url: instance.resource && instance.resource.resource_url,
      // 合并接口的字段。
      detail: '',
      img: ''
    }
    const extraData = this.extraData as ExtraData
    if (instance && instance.resource && instance.resource.sensitive_words.length > 0) {
      extraData.word_data = instance.resource.sensitive_words.map((item) => ({
        word_name: item.name,
        sensitive_type: item.sensitive_type
      }))
    } else {
      extraData.word_data = []
    }

    this.sendMessageData = {
      instance_id: instance.id,
      img: '',
      detail: ''
    }
  }

  private onChangeShowViewTask(val: boolean) {
    this.isShowViewTask = val
  }
  // 记录点击'处理'按钮
  public async getFinishTime(id, task) {
    let data = {
      instance_id: id,
      task_id: task,
      step: 'deal'
    }
    await recordFinishTime(data)
  }
}
